var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$trial() && !_vm.$subscription() && [_vm.constants.ROLE_ADMIN_PAYEUR, _vm.constants.ROLE_ADMIN_ENTREPRISE].includes(_vm.role) ? _c('div', [_c('p', [_vm._v("\n    Il vous reste " + _vm._s(_vm.dayBeforeTrialEnd) + " jour"), _vm.dayBeforeTrialEnd > 1 ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v("\n    avant la fin de votre période d'essai.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    Vous pouvez faire évoluer votre offre\n    "), _c('router-link', {
    staticClass: "text-pink-600 underline cursor-pointer",
    attrs: {
      "to": {
        name: 'Subscriptionchoice'
      }
    }
  }, [_vm._v("\n      ici\n    ")])], 1)]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }